import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { TranslationRepositoryService } from './translation-repository.service';
import { Observable, tap } from 'rxjs';
import { TranslationConfig } from './translation.types';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  translationConfig: TranslationConfig = {
    cultures: ['en-US'],
  };

  constructor(
    private vendorTranslation: TranslocoService,
    private translationRepository: TranslationRepositoryService
  ) {}

  public initTranslation(): Observable<TranslationConfig | null> {
    return this.translationRepository.getTranslationConfig().pipe(
      tap(config => {
        if (config) {
          this.translationConfig = Object.assign(this.translationConfig, config);
          this.vendorTranslation.setAvailableLangs(config.cultures);
        }
      })
    );
  }

  public getActiveLanguage(): string {
    return this.vendorTranslation.getActiveLang();
  }
}
